import { capitalizeFirstLetter } from '@/helpers/text'

export const getProcessingFeeLabel = (siteConfig) =>
  siteConfig.copy?.processingFeeLabel ||
  (siteConfig.features.processingFeeNonRefundable ? 'non-refundable processing fee' : 'processing fee')

export const getProcessingFeeTitle = (siteConfig) =>
  getProcessingFeeLabel(siteConfig).split(' ').map(capitalizeFirstLetter).join(' ')

export const getProcessingFeeSubtitle = (siteConfig) =>
  siteConfig.copy?.processingFeeSubtitle || 'For credit card payments'

export const getProcessingFeeGLFields = (siteConfig) => ({
  glAccount: siteConfig.glAccounts?.processingFee,
  glclass: siteConfig.glClasses?.processingFee,
  glsubclass: siteConfig.glSubclasses?.processingFee,
})

export const hasProcessingFee = (siteConfig) =>
  Boolean(siteConfig.features.processingFeeRate || siteConfig.features.processingFeeFlat)

export const hasRequiredProcessingFee = (siteConfig) =>
  hasProcessingFee(siteConfig) && !siteConfig.features.processingFeeOptional

export const getProcessingFeeDescription = (siteConfig) =>
  siteConfig.features.processingFeeFlat
    ? `$${siteConfig.features.processingFeeFlat}`
    : `${siteConfig.features.processingFeeRate * 100}%`

// Charges are in cents and Canvas rounds line items half up
export const roundToCents = (value) => Math.round(parseFloat((Number(value) * 100).toPrecision(12))) / 100

export const rateProcessingFee = (amount, rate) => (rate ? roundToCents(Math.max(amount * rate, 0)) : 0)

export const processingFeeAmountInCart = (items = []) => {
  const feeItem = items.find((item) => item.type === 'charge' && item.feeType === 'processingFee')
  return Number(feeItem?.totalCost ?? feeItem?.effectiveCost ?? feeItem?.nonMemberCost ?? 0)
}

// Card remainder after gift cert / account credit, ignoring any processing-fee line already in the cart.
export const cardBalanceBeforeFee = ({
  cartTotal = 0,
  giftCertificateTotal = 0,
  accountCredit = 0,
  processingFeeAmount = 0,
} = {}) => {
  const remaining =
    Number(cartTotal) -
    Number(processingFeeAmount || 0) -
    Number(giftCertificateTotal || 0) -
    Number(accountCredit || 0)
  return Math.max(Number(remaining.toFixed(2)), 0)
}
